import React from 'react'
import { BaseNodeProps } from '../../base/types'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { GenerateReportConfiguration } from './GenerateReportForm'

const GenerateReport = React.memo(
  ({ data, isConnectable }: BaseNodeProps<GenerateReportConfiguration>) => {
    const title = 'Générer un rapport'
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'puzzle-piece'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default GenerateReport
